/**
 * Tracking function for purchase events
 *
 * @param {object} data - tracking data
 * @param {string} data.currency - currency value
 * @param {number} data.value - monetary value
 * @param {string} data.rate_plan_code - item rate plan code
 * @param {string} data.product - product name
 * @param {string} data.product_type - product type
 * @param {string} data.periodicity - product periodicity
 * @param {string} [data.test_group] - FF test group
 */
export const purchaseTrackingEvent = (data) => {
  const { currency, value, rate_plan_code, product, product_type, periodicity, test_group, } = data;

  window.plausible('purchase', {
    props: {
      currency,
      value,
      rate_plan_code,
      product,
      product_type,
      periodicity,
      test_group,
    },
    revenue: {
      currency,
      amount: value,
    },
  });
};

// Disable all Plausible tracking for specific user browser.
export const excludeUserFromTracking = () => {
  if (location.host !== 'www.devex.com') return;

  try {
    localStorage.setItem('plausible_ignore', 'true');
  } catch (error) {
    // If max quota has been reached, clear all the local storage
    if (error?.name === 'QuotaExceededError') {
      localStorage.clear();
      localStorage.setItem('plausible_ignore', 'true');
    }
  }
};

// Track user registration in Plausible if it has not been tracked yet
export const registrationTrackingEvent = () => {
  try {
    const accountRegistered = JSON.parse(localStorage.getItem('account_registration'));
    if (accountRegistered) return;

    window.plausible('account_registration');
    localStorage.setItem('account_registration', 'true');
  } catch (error) {
    // If max quota has been reached, clear all the local storage
    if (error?.name === 'QuotaExceededError') {
      localStorage.clear();
      localStorage.setItem('account_registration', 'true');
    }
    window.plausible('account_registration');
  }
};
